import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78f5affd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=78f5affd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5affd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f5affd')) {
      api.createRecord('78f5affd', component.options)
    } else {
      api.reload('78f5affd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78f5affd&scoped=true&", function () {
      api.rerender('78f5affd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadImage/index.vue"
export default component.exports